import { render, staticRenderFns } from "./interactionQuestion.vue?vue&type=template&id=25f12cea&scoped=true"
import script from "./interactionQuestion.vue?vue&type=script&lang=js"
export * from "./interactionQuestion.vue?vue&type=script&lang=js"
import style0 from "./interactionQuestion.vue?vue&type=style&index=0&id=25f12cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f12cea",
  null
  
)

export default component.exports